(function () {
  var LOGGED = !!window.__IS_LOGGED__;

  var SEL = {
    atc: '.hdt-card-product__atc',
    talla: '.hdt-talla-input'
  };

  function applyGuard(root) {
    if (LOGGED) return;
    var scope = root || document;

    // Deshabilitar ATC
    scope.querySelectorAll(SEL.atc).forEach(function (btn) {
      if (btn.dataset.jeyGuard === '1') return;
      btn.dataset.jeyGuard = '1';
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('jey-guard-disabled');

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var loginUrl = (window.JEY && window.JEY.loginUrl) ? window.JEY.loginUrl : '/account/login';
        window.location.href = loginUrl;
      }, { capture: true });
    });

    // Deshabilitar inputs de talla
    scope.querySelectorAll(SEL.talla).forEach(function (inp) {
      if (inp.dataset.jeyGuard === '1') return;
      inp.dataset.jeyGuard = '1';
      inp.disabled = true;
      inp.setAttribute('aria-disabled', 'true');
      inp.classList.add('hdt-talla-disabled');

      // Evita que el usuario “fuerce” tipeo
      inp.addEventListener('keydown', function (e) { e.preventDefault(); }, { capture: true });
      inp.addEventListener('input',  function (e) { e.target.value = ''; e.preventDefault(); }, { capture: true });
      inp.addEventListener('focus',  function (e) { e.target.blur(); }, { capture: true });
    });
  }

  //Ocultar precios por css
  function addHidePricesCSS() {
    if (LOGGED) return;
    if (document.getElementById('jey-guard-hide-prices-style')) return;

    var css =
      '.jey-hide-prices .hdt-price-total,' +
      '.jey-hide-prices .hdt-price-total-variant,' +
      '.jey-hide-prices .hdt-price .hdt-money,' +
      '.jey-hide-prices .hdt-compare-at-price .hdt-money{' +
        'visibility:hidden!important;' +
      '}';

    var st = document.createElement('style');
    st.id = 'jey-guard-hide-prices-style';
    st.type = 'text/css';
    st.appendChild(document.createTextNode(css));
    document.head.appendChild(st);

    document.body.classList.add('jey-hide-prices');
  }

  function removeHidePricesCSS() {
    var st = document.getElementById('jey-guard-hide-prices-style');
    if (st) st.parentNode.removeChild(st);
    document.body.classList.remove('jey-hide-prices');
  }

  //Observer para carga por scroll/ajáx (aplica a inputs/ATC)
  function setupObserver() {
    if (LOGGED) return;
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.addedNodes && m.addedNodes.length) {
          m.addedNodes.forEach(function (n) {
            if (n.nodeType === 1) applyGuard(n);
          });
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });

    ['theme:loading:done', 'products:loaded', 'shopify:section:load', 'ajax:loaded']
      .forEach(function (ev) {
        document.addEventListener(ev, function () { applyGuard(document); });
      });
  }

  // Arranque
  function init() {
    if (!LOGGED) {
      addHidePricesCSS();
      applyGuard(document);
      setupObserver();
    } else {
      removeHidePricesCSS();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Helpers para depurar
  window.JeyGuard = {
    enabled: function () { return !LOGGED; },
    apply: applyGuard
  };
})();
